import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

import WebVoiceTranslator from './components/WebVoiceTranslator';
import UserContext from './context/UserContext';
import { MeetingProvider } from './components/MeetingContext';


function App() {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <UserContext.Provider value={{ user, setUser, isLoggedIn, setIsLoggedIn }}>
      <Router>
        <div className="App">

          <div className="main-content">
            <div className="voice-panel">
              <MeetingProvider>
                <WebVoiceTranslator />
              </MeetingProvider>
            </div>
          </div>
        </div>
      </Router>
    </UserContext.Provider>
  );
}

export default App;